module.exports = "<div class=\"ytplayer\" (click)=\"openVideo()\">\r\n    <img [src]=\"thumbnail\">\r\n</div>"